import script from "./DBOptionsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DBOptionsChart.vue?vue&type=script&setup=true&lang=ts"

import "./DBOptionsChart.vue?vue&type=style&index=0&id=9b206550&lang=css"

const __exports__ = script;

export default __exports__